<script>
  export let inTable = false, compact = false, clz = '';
</script>

{#if inTable}
  <tr style="display: block; width: 100%;" class="loader-tr {clz}">
    <td style="display: block; width: 100%; max-width: 100%;">
      <div class="small-centered-loading-icon" />
    </td>
  </tr>
{:else if compact === true}
  <div class="small-centered-loading-icon {clz}"></div>
{:else if compact === 'big'}
  <div class="big-centered-loading-icon {clz}"></div>
{:else}
  <div class="loadingBarContainer block relative full-size {clz}">
    <div class="loadingBarOverlay"></div>
    <div class="loadingBarContent"></div>
  </div>
{/if}
